import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from "@angular/common/http";
import { Observable, retry, timer } from "rxjs";

@Injectable()
export class HttpRetryInterceptor implements HttpInterceptor {
    public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(retry({ count: 1, delay: this._shouldRetry }));
    }

    private _shouldRetry(error: HttpErrorResponse) {
        // Http 500 appear as status code 0
        if (error.status == 0) {
            return timer(500);
        }
        throw error;
    }
}
